module.exports = __webpack_public_path__ + "img/B.d5202234.png";